export const randomString = (length = 6, suffix = '', prefix = '') => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    if(prefix) prefix = `${prefix}_`
    if(suffix) suffix = `_${suffix}`

    return `${prefix}${result}${suffix}`;
}

const AVATAR_GRADIENTS = [
    { background: 'linear-gradient(135deg, #ccff33, #99cc00)', color: '#0C0E12' },
    { background: 'linear-gradient(135deg, #339999, #66cccc)', color: '#ffffff' },
    { background: 'linear-gradient(135deg, #7c3aed, #a78bfa)', color: '#ffffff' },
    { background: 'linear-gradient(135deg, #d97706, #fbbf24)', color: '#0C0E12' },
    { background: 'linear-gradient(135deg, #e11d48, #fb7185)', color: '#ffffff' },
    { background: 'linear-gradient(135deg, #0284c7, #38bdf8)', color: '#ffffff' },
]

export const getInitials = (name = '') => {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
    if (parts.length === 0) return '?'
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
}

export const getAvatarGradient = (key = '') => {
    const str = String(key || '')
    let hash = 0
    for (let i = 0; i < str.length; i++) hash = (hash * 31 + str.charCodeAt(i)) | 0
    return AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length]
}

export const safeLower = (value = '') => String(value ?? '').toLowerCase()

const HTML_ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

export const escapeHtml = (value = '') => String(value ?? '').replace(/[&<>"']/g, char => HTML_ENTITIES[char])

export const nl2br = (value = '') => escapeHtml(value).replace(/\n/g, '<br>')

export const capitalize = (value = '') => {
    const text = String(value ?? '')
    return text.charAt(0).toUpperCase() + text.slice(1)
}

export const toDate = (value) => {
    if (!value) return null
    if (typeof value.toDate === 'function') return value.toDate()
    const date = value.seconds != null ? new Date(value.seconds * 1000) : new Date(value)
    return isNaN(date.getTime()) ? null : date
}

export const runWithConcurrency = async (items, limit, task) => {
    const queue = [...items]
    const size = Math.min(Math.max(1, limit), queue.length)
    const workers = Array.from({ length: size }, async () => {
        while (queue.length) {
            await task(queue.shift())
        }
    })
    await Promise.all(workers)
}

export const debounce = (func, wait, immediate = false) => {
    const timers = new WeakMap()
    const shared = {}
    return function (...args) {
        const context = this
        const scope = context || shared
        const running = timers.get(scope)
        const callNow = immediate && !running
        clearTimeout(running)
        timers.set(scope, setTimeout(() => {
            timers.delete(scope)
            if (!immediate) func.apply(context, args)
        }, wait))
        if (callNow) func.apply(context, args)
    }
}

export const civilDaysBetween = (from, to) => {
    if (!from || !to) return null
    const a = Date.parse(`${String(from).slice(0, 10)}T00:00:00Z`)
    const b = Date.parse(`${String(to).slice(0, 10)}T00:00:00Z`)
    if (isNaN(a) || isNaN(b)) return null
    return Math.round((b - a) / 86400000)
}
